import { render } from "./S216922.vue?vue&type=template&id=1eab55b9"
const script = {}
script.render = render

export default script